import React, { useEffect, useState } from 'react';
import CropDinIcon from '@material-ui/icons/CropDin';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import { makeStyles } from '@material-ui/core/styles';
import { Zoom } from '@material-ui/core';
import StyledMenu from '../StyledMenu.js';
import IconButton from '@material-ui/core/IconButton';
import {
    EMOJI_LIST,
    EMOJI_PATH, MUSIC_LIST, MUSIC_PATH,
    SHAPES_3D_LIST,
    SHAPES_3D_PATH,
    SHAPES_LIST,
    SHAPES_PATH,
    SVG_ELEMENTS_PATH,
} from '../../../constants.js';
import { addSvgToElemIfExists, addSVGToWindowCache, getSVGFromWindowCache } from '../../../common/utils.js';
import apiUtil from '../../../Api/apiUtil.js';
import CubeIcon from '../../icons/CubeIcon.js';
import { GA_EVENT_TREE } from '../../../gaConstants';

const useStyles = makeStyles(() => ({
    menu: {},
    tabs: {
        display: 'inline-flex',
        borderStyle: 'solid',
        borderBottom: '#07767D',
        borderTopStyle: 'none',
        borderBottomStyle: 'solid',
        borderLeftStyle: 'none',
        borderRightStyle: 'none',
        marginLeft: '0.1rem',
        marginRight: '0.1rem',
    },
    selectedTab: {
        marginLeft: '0.1rem',
        marginRight: '0.1rem',
        borderStyle: 'solid',
        borderBottom: 'none',
        borderRadius: '5px 5px 0px 0px',
        boxShadow: '0 0 0 2px #07767D33',
        borderColor: '#07767D',
        width: '5rem',
        textAlign: 'center',
    },
    unSelectedTab: {
        marginLeft: '0.1rem',
        marginRight: '0.1rem',
        borderStyle: 'solid',
        borderBottom: 'none',
        borderRadius: '5px 5px 0px 0px',
        // boxShadow: '0 0 0 2px #07767D33',
        borderColor: '#FFFFFF',
        width: '5rem',
        textAlign: 'center',
    },
    content: {
        position: 'relative',
        width: '100%',
        height: '12rem',
        padding: '0.5rem',
    },
    svgContainer: {
        display: 'flex',
        position: 'absolute',
        width: '100%',
        flexWrap: 'wrap',
        gap: '8px',
    },
    itemRenderer: {
        width: '42px',
        height: '42px',
        padding: '1px',
        borderStyle: 'solid',
        borderRadius: '5px 5px',
        boxShadow: '0 0 0 2px #FFF',
        borderColor: '#FFF',
        strokeWidth: '20',

        '&:hover': {
            borderStyle: 'solid',
            borderRadius: '5px 5px',
            boxShadow: '0 0 0 2px #07767D33',
            borderColor: '#07767D88',
        },

    },
}));


const TAB_SECTIONS = [{
    path: SHAPES_PATH,
    items: SHAPES_LIST,
    icon: (<CropDinIcon fontSize={'large'} />),
}, {
    path: SHAPES_3D_PATH,
    items: SHAPES_3D_LIST,
    icon: (<CubeIcon fontSize={'large'} />),
}, {
    path: EMOJI_PATH,
    items: EMOJI_LIST,
    icon: (<InsertEmoticonIcon fontSize={'large'} />),
}, {
    path: MUSIC_PATH,
    items: MUSIC_LIST,
    icon: (<MusicNoteIcon fontSize={'large'} />),
}];

const ShapeSelector = ({ anchorShapeTool, handleClose, handleSelection }) => {
    const classes = useStyles();

    const [currentTab, setCurrentTab] = useState(0);

    useEffect(() => {
        TAB_SECTIONS.forEach((section) => {
            section.items.forEach(el => {
                let url = `${SVG_ELEMENTS_PATH}${section.path}/${el}`;
                let svg = getSVGFromWindowCache(url);
                let idd = `shape-selector-item-${SVG_ELEMENTS_PATH}${section.path}/${el}`;
                if (!svg) {
                    apiUtil.concurrentURLGet(url).then((res) => {
                        addSVGToWindowCache(url, res.data);
                        addSvgToElemIfExists(idd, res.data);
                    });
                } else {
                    addSvgToElemIfExists(idd, svg);
                }
            });
        });

    });

    const renderSection = (index, section) => {
        return (
            <Zoom in={currentTab === index} key={`shape-container-${index}`}>
                <div className={classes.svgContainer}>
                    {section.items.map((el, index) => {
                        return (<div key={`shape-item-${section.path}-${index}`} className={classes.itemRenderer}
                                     style={{ strokeWidth: 48 }}
                                     id={`shape-selector-item-${SVG_ELEMENTS_PATH}${section.path}/${el}`}
                                     onClick={() => {
                                         window.logAppActivity(GA_EVENT_TREE.lessonPage.toolSelection.shapeInsert, undefined, { group: section.path });
                                         handleSelection(`${section.path}/${el}`);
                                     }}>
                        </div>);
                    })}
                </div>
            </Zoom>
        );
    };

    return (<StyledMenu
            id='shape-menu'
            anchorEl={anchorShapeTool}
            keepMounted
            open={Boolean(anchorShapeTool)}
            onClose={handleClose}
        >

            <div className={classes.menu}>
                <div className={classes.tabs}>
                    {TAB_SECTIONS.map((el, index) => {
                        return (<div className={currentTab === index ? classes.selectedTab : classes.unSelectedTab}
                                     onClick={() => {
                                         setCurrentTab(index);
                                     }} key={`shatpe-tab-section${index}`}>
                            <IconButton>
                                {el.icon}
                            </IconButton>
                        </div>);
                    })}
                </div>
                <div className={classes.content}>
                    {TAB_SECTIONS.map((el, index) => {
                        return renderSection(index, el);
                    })}
                </div>
            </div>
        </StyledMenu>
    );
};

export default ShapeSelector;